module.exports = "/cover-page.1fc48b4fa219f91c616f6407020e34af.png";